// extracted by mini-css-extract-plugin
export var root = "Khz1";
export var rootImage = "hL-A";
export var rootPicture = "a5Xa";
export var rootPictureWrapper = "Mzp2";
export var rootProduct = "FE+w";
export var rootProductTitle = "WJef";
export var rootTileLink = "v0X3";